import OrdersModel from "../pages/orders/model/OrdersModel";
import Endpoint from "../services/endpoint";
import CallApi from "../services/request-helper";
import DateUtility from "../utils/date-utility";

const BASE_API = process.env.REACT_APP_BASE_API;

const getListOrder = async (data) => {
  const url = BASE_API + Endpoint.listOrder;
  const response = await CallApi({ url, method: "POST", data });
  const res1 = response !== "undefined" ? response.data : null;
  const res2 = res1 !== null ? res1.data : null;
  const list = res2 !== null ? res2.content : null;

  let array = [];
  for (let i = 0; i < list.length; i++) {
    const element = list[i];
    const item = new OrdersModel({
      id: element.orderMerchantId,
      status: element.orderStatus,
      invoice: element.invoiceNumber,
      customerName: element.customerName,
      dateCreated: DateUtility.formatDate(element.orderDate, "full"),
      paymentMethod: getPaymentMethod(element),
      address: element.receiverAddress,
      courier:
        element.shipmentProvider === "SELF_PICKUP"
          ? element.shipmentProvider
          : element.shipmentProvider + " - " + element.serviceCode,
      pickupBy: element.pickupBy === null ? "-" : element.pickupBy,
      receiptNumber: element.receiptNumber,
      receivedBy:
        element.receivedBy === "" || element.receivedBy === null
          ? "-"
          : element.receivedBy,
      receivedDate:
        element.receivedDate !== ""
          ? DateUtility.formatDate(element.receivedDate, "half")
          : "",
      product: element.products,
      shipping: element.totalShippingCost,
      fee: element.applicationServiceFee,
      insuranceFee: element.totalShippingInsurance,
      complaint: element.remarkComplaint,
      total: element.totalPrice,
      commission: element.commission,
      transactionServiceFee: element.totalTransactionServiceFee,
      totalShippingPromo: element.totalShippingPromo,
      startSelfPickupDate:
        element.startSelfPickupDate !== ""
          ? DateUtility.formatDate(element.startSelfPickupDate, "half")
          : "",
      endSelfPickupDate:
        element.endSelfPickupDate !== ""
          ? DateUtility.formatDate(element.endSelfPickupDate, "half")
          : "",
      chatId: element.chatId,
      customerId: element.customerId,
    });
    array.push(item);
  }

  let obj = {};
  obj.error = response.error;
  obj.message = response.message;
  obj.hasMore = res1.hasMore;
  obj.data = array;

  return obj;
};

const getPaymentMethod = (element) => {
  const paymentMethod = element.paymentMethod;
  const paymentChannel = element.paymentChannel;

  if (!paymentMethod || !paymentChannel) {
    return "";
  }

  const cleanedPaymentMethod = paymentMethod.replace("_", " ");
  if (paymentChannel === "CREDIT_CARD") {
    return cleanedPaymentMethod;
  } else {
    const combinedPaymentMethod = `${cleanedPaymentMethod} ${paymentChannel}`;
    return combinedPaymentMethod;
  }
};

const getTrackingOrder = async (data) => {
  const url = BASE_API + Endpoint.trackingOrder;
  const response = await CallApi({ url, method: "POST", data });
  const res1 = response !== "undefined" ? response.data : null;
  const res2 = res1 !== null ? res1.data : null;

  let obj = {};
  obj.error = response.error;
  obj.message = response.message;
  obj.data = res2;

  return obj;
};

const setPickUpOrder = async (data) => {
  const url = BASE_API + Endpoint.setPickupOrder;
  const response = await CallApi({ url, method: "POST", data });
  return response;
};

const getResi = async (data) => {
  const url = BASE_API + Endpoint.getResi;
  const response = await CallApi({ url, method: "POST", data });
  return response;
};

const completeOrder = async (data) => {
  const url = BASE_API + Endpoint.completeOrder;
  const response = await CallApi({ url, method: "POST", data });
  return response;
};

const cancelOrder = async (data) => {
  const url = BASE_API + Endpoint.cancelOrder;
  const response = await CallApi({ url, method: "POST", data: data });
  return response;
};

const createChatToCustomer = async (data) => {
  const url = BASE_API + Endpoint.createChat;
  const response = await CallApi({ url, method: "POST", data });
  const res1 = response !== "undefined" ? response.data : null;
  const res2 = res1 !== null ? res1.data : null;

  let obj = {};
  obj.error = response.error;
  obj.message = response.message;
  obj.data = res2;

  return obj;
};

const OrderRepository = {
  getListOrder,
  getTrackingOrder,
  setPickUpOrder,
  getResi,
  completeOrder,
  cancelOrder,
  createChatToCustomer,
};

export default OrderRepository;
